module.exports = __webpack_public_path__ + "media/images/icon_new-22f6fba3851888dea69a7c335b6fe365.png";